import React, { ChangeEvent } from "react";
import * as S from "./signUpForm.style";
import { Button } from "../../atoms/Buttons";
import { SignUpType } from "../../../types/signup.types";
import { ReactComponent as IconLeftArrow } from "../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRightArrow } from "../../../styles/assets/svg/icon-right-arrow.svg";

interface SignUpProps {
  onSubmit: (data: SignUpType) => void;
  register: any;
  setValue: any;
  handleSubmit: any;
  errors: any;
  isButtonTrue: boolean;
  onBackPageClickHandler: () => void;
}

const SignUpForm = ({
  register,
  setValue,
  handleSubmit,
  onSubmit,
  errors,
  isButtonTrue,
  onBackPageClickHandler,
}: SignUpProps) => {
  const handlePhoneNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
    // 휴대폰 번호 입력시 자동으로 '-' 추가
    const phoneNumber = e.target.value.replace(/[^0-9]/g, "");
    let result = "";
    if (phoneNumber.length < 4) {
      result = phoneNumber;
    } else if (phoneNumber.length < 7) {
      result = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3);
    } else if (phoneNumber.length < 11) {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 6) +
        "-" +
        phoneNumber.substring(6);
    } else {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 7) +
        "-" +
        phoneNumber.substring(7);
    }
    setValue("phoneNumber", result);
  };

  return (
    <S.SignUpFormLayout onSubmit={handleSubmit(onSubmit)}>
      <S.SignUpContentBox>
        <S.SignUpFormHeader>
          <S.SignUpFormHeaderTop>
            <S.SignUpStepBox>
              <p>2 / 9 단계</p>
            </S.SignUpStepBox>
            <S.SignUpStepTitle> 회원등록 </S.SignUpStepTitle>
          </S.SignUpFormHeaderTop>
          <S.SignUpFormContentTitle>
            <span>회원가입 정보</span>를 입력해 주세요
          </S.SignUpFormContentTitle>
        </S.SignUpFormHeader>

        <S.InputContentBox>
          <S.InputContent>
            <S.InputBoxLayout>
              <S.LabelContextBox>기본정보 입력</S.LabelContextBox>
              <S.InputBox>
                <input
                  type="text"
                  id="userId"
                  required={true}
                  autoComplete="off"
                  placeholder="아이디"
                  autoCapitalize="none"
                  {...register("userId")}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["userId"]?.message}</p>
              ) : (
                ""
              )}
              <S.InputBox>
                <input
                  type="password"
                  id="userPw"
                  required={true}
                  autoComplete="off"
                  placeholder="비밀번호"
                  autoCapitalize="none"
                  {...register("password")}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["password"]?.message}</p>
              ) : (
                ""
              )}
              <S.CautionContextBox>
                <div>※</div>
                <div>
                  비밀번호는 8~12자리의 영문자, 숫자, 특수문자 중 2가지 이상의
                  조합으로 설정 가능합니다.
                </div>
              </S.CautionContextBox>
            </S.InputBoxLayout>
            <S.InputBoxLayout>
              <S.InputBox>
                <input
                  type="password"
                  autoComplete="off"
                  autoCapitalize="none"
                  placeholder="비밀번호 확인"
                  {...register("userPwCheck")}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["userPwCheck"]?.message}</p>
              ) : (
                ""
              )}
            </S.InputBoxLayout>
          </S.InputContent>

          <S.InputContent>
            <S.InputBoxLayout>
              <S.LabelContextBox>기본정보 입력</S.LabelContextBox>
              <S.InputBox>
                <input
                  type="text"
                  required={true}
                  placeholder="[필수] 이름"
                  {...register("username")}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["username"]?.message}</p>
              ) : (
                ""
              )}
            </S.InputBoxLayout>
            <S.InputBoxLayout>
              <S.InputBox>
                <input
                  type="text"
                  required={true}
                  placeholder="[필수] 핸드폰 번호"
                  {...register("phoneNumber")}
                  maxLength={13}
                  onChange={(e) => {
                    handlePhoneNumberChange(e);
                  }}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["phoneNumber"]?.message}</p>
              ) : (
                ""
              )}
            </S.InputBoxLayout>
            <S.InputBoxLayout>
              <S.InputBox>
                <input
                  type="text"
                  placeholder="[선택] 이메일"
                  {...register("email")}
                />
              </S.InputBox>
              {errors ? (
                <p className="error-text">{errors["email"]?.message}</p>
              ) : (
                ""
              )}
            </S.InputBoxLayout>
          </S.InputContent>
        </S.InputContentBox>
      </S.SignUpContentBox>
      <S.ButtonBox>
        <div className="small">
          <Button
            type="button"
            size="full"
            color="transparent"
            onClick={onBackPageClickHandler}
          >
            <IconLeftArrow width={20} height={20} />
            이전
          </Button>
        </div>
        <Button type="submit" size="full" disabled={!isButtonTrue}>
          다음
          <IconRightArrow width={20} height={20} />
        </Button>
      </S.ButtonBox>
    </S.SignUpFormLayout>
  );
};

export default SignUpForm;
